// extracted by mini-css-extract-plugin
export default {"label":"chat_attachment_input-module___label___c469df30","disabled":"chat_attachment_input-module___disabled___c9a36b94","input":"chat_attachment_input-module___input___e1d7b967"};